(function () {
  'use strict';

  function registerEntityHomePageController($uibModal, entityType, sessionData, $state) {

    var vm = this;
    vm.isLoggedIn = !sessionData.IsGuest;
    vm.openModal = function() {
      var modalInstance = $uibModal.open({
          templateUrl: 'registration/templates/homepageRegistrationModal.html',
          controller: 'homepageRegistrationModalController',
          windowClass: 'home-page-registration-modal',
          resolve: {
            entityType: function () { return entityType; }
          }
      });

      return modalInstance.result.then(function (result) {
          // if (result.accepted && result.clicked) {
          //   vm.model.HasAcceptedTermsOfService = true;
          //   vm.submit();
          // }
          // do nothing
      });
    }

    
  }

  registerEntityHomePageController.$inject = ['$uibModal', 'entityType', 'sessionData','$state'];

  angular.module('ecap.registration').controller('registerEntityHomePageController', registerEntityHomePageController);
})();